import reducer from './reducers';

export { getFolders, createFolder, setCurrent, deleteFolder, updateFolder } from './actions';

export default reducer;
